<template>
  <div class="root-box">
    <!-- <div>
      数字证书验证申请
    </div> -->
    <div class="tip-box flex-1" v-if="verifiyState < 10">
      <h2 class="title">妥妥递数字证书申请验证</h2>
      <div class="content-box">
        <p class="content">
          机构{{manegerName}}正通过妥妥递私募基金综合服务系统申请颁发您的数字证书，
          根据电子签名法规定，颁发数字证书前，需确保为申请人真实意愿并需校验真实身份，再进行身份认证签，请确认：
        </p>
        <br />
        <br />
        <p class="content">
          本次数字证书申请为本人（{{model.userName}}，{{showIdNo}}）真实意愿！
        </p>
      </div>
      <div class="bottom">
        <p>
          <cube-checkbox v-model="startVerifiyState" style="textAlian:center">我已确认以上内容</cube-checkbox>
        </p>
        <cube-button :disabled="!startVerifiyState" @click="startVerifiy">开始身份认证</cube-button>
      </div>
    </div>
    <!-- <div v-else-if="[0,1,2].includes(verifiyState)"></div> -->
    <cube-form
      v-else-if="verifiyState === 10"
      :model="model"
      :immediate-validate="false"
      @submit.prevent="submitHandler"
      class="four-elements-form flex-1"
    >
      <cube-form-group class="white-background">
        <cube-form-item :field="fields[0]"></cube-form-item>
        <cube-form-item :field="fields[1]">
          <cube-input :value="showIdNo" ></cube-input>
        </cube-form-item>
        <cube-form-item :field="fields[2]"></cube-form-item>
        <cube-form-item :field="fields[3]"></cube-form-item>
        <cube-form-item :field="fields[4]">
          <SMSInput v-model="model.authCode" :mobile="model.mobileNo"/>
        </cube-form-item>
      </cube-form-group>
      <div class="four-elements-botton">
        <div class="four-elements-span">请您仔细准确填写认证信息（本页面所填信息仅用于身份认证使用）</div>
        <cube-form-item class="white-background" :field="fields[5]"></cube-form-item>
      </div>
    </cube-form>
    <div v-else-if="verifiyState === 20" class="success-box flex-1">
      <img :src="require('@/assets/verifiy-success.png')" width="160" height="160" />
      <h3 class="info">您已通过数字证书申请身份验证</h3>
      <p class="sub-info">妥妥递将根据数字证书印章采集表中收集的印章图案进行印章制作，请耐心等待</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import config from '@/env';

import Liveness from '@/components/liveness';
import { uploadHeaders } from '@/utils/crypto';
import { getDiySealAuthenticationlInfo, authentication } from '@/api/seal';
import { tencentLiveCode, tencentLivenessRecognition } from '@/api/tool';
import verifyFail from '@/assets/verifiy-fail.png';
import SMSInput from './components/SMSInput.vue';

export default {
  name: 'DigitalCertificateVerification',

  components: {
    SMSInput,
  },

  data() {
    return {
      startVerifiyState: false,
      verifiyState: -1, // -1: 未开始, 0: 眨眼, 1: 张嘴, 2: 摇头, 10: 银行卡四要素认证, 20: 已通过

      toast: {},

      manegerName: '',

      model: {
        userName: '',
        idNo: '',
        auBankAccount: '',
        mobileNo: '',
        authCode: '',
      },
      fields: [
        {
          type: 'input',
          modelKey: 'userName',
          label: '姓名',
          props: {
            placeholder: '请输入姓名',
            readonly: true,
          },
          rules: {
            required: true,
          },
        },
        {
          type: 'input',
          modelKey: 'idNo',
          label: '身份证号',
          props: {
            placeholder: '请输入身份证号',
            readonly: true,
          },
          rules: {
            required: true,
          },
        },
        {
          type: 'input',
          modelKey: 'auBankAccount',
          label: '银行卡号',
          props: {
            placeholder: '请输入银行卡号',
          },
          rules: {
            required: true,
          },
        },
        {
          type: 'input',
          modelKey: 'mobileNo',
          label: '认证手机号',
          props: {
            placeholder: '请输入银行预留手机号',
          },
          rules: {
            required: true,
          },
        },
        {
          type: 'input',
          modelKey: 'authCode',
          label: '验证码',
          rules: {
            required: true,
          },
        },
        {
          type: 'submit',
          label: '提交',
        },
      ],

      actionSequence: '', // 动作序列
    };
  },

  computed: {
    showIdNo() { return this.model.idNo.replace(/.{4}(.{4})$/, '****$1'); },
    sealId() { return this.$route.params.sealId; },
  },

  created() {
    this.getDiySealAuthenticationlInfo();
    this.getTencentLiveCode();
  },


  methods: {
    async getDiySealAuthenticationlInfo() {
      const params = { sealId: this.sealId };
      const res = await getDiySealAuthenticationlInfo(params);
      if (res.code === 0) {
        this.model.userName = res.data.bean.userName;
        this.model.idNo = res.data.bean.idNo;
        this.manegerName = res.data.bean.manegerName;
        // --0：待认证 1：认证通过 2：认证未通过';
        this.verifiyState = [-1, 20, -1][res.data.bean.auState || 0];
      } else {
        console.error(res.msg);
        this.$createToast({
          txt: res.msg,
          type: 'loading',
          mask: true,
          time: 0,
        }).show();
      }
    },
    async getTencentLiveCode() {
      const res = await tencentLiveCode({
        type: 2,
      });
      if (res.code === 0) {
        this.actionSequence = res.data.bean.actionSequence;
      } else {
        console.error(res.msg);
        this.$createToast({
          txt: res.msg,
          type: 'loading',
          mask: true,
          time: 0,
        }).show();
      }
    },
    startVerifiy() {
      // 设置活体检测动作
      this.verifiyState = 0;
      this.livenessStart();
    },
    // 检测
    livenessAvailable() {
      if (Liveness.isAvailable) {
        return true;
      }
      const toast = this.$createToast({
        time: 1000,
        txt: '不支持当前浏览器',
      });
      toast.show();
      return false;
    },
    async livenessStart() {
      if (!this.livenessAvailable()) {
        return;
      }
      const result = await this.liveness(this.actionSequence).finally(() => {
        if (this.toast && this.toast.hide) {
          this.toast.hide();
        }
      });
      // 人脸识别现在只识别眨眼动作
      const res = await authentication({
        sealId: this.sealId,
        auType: 1,
        faceRecognitionResults: JSON.stringify(result.faceRecognitionResults),
        recognizeAvatars: JSON.stringify(result.faceVideo),
      });
      if (res.code === 0) {
        this.verifiyState = 20;
      } else {
        this.$createToast({
          type: 'txt',
          txt: res.msg,
          mask: true,
          time: 2000,
        }).show();
      }
    },
    /**
     * linkface 活体检测 + 人脸识别
     * action 0: 眨眼, 1: 张嘴, 2: 摇头
     */
    liveness(action) {
      return new Promise((resolve, reject) => {
        const livenessErrorHandler = (errorMessage) => {
          if (this.toast && this.toast.hide) {
            this.toast.hide();
          }
          this.$createDialog({
            type: 'confirm',
            confirmBtn: {
              text: '四要素认证',
            },
            cancelBtn: {
              text: '人脸识别',
            },
            onConfirm: () => { // 转到四要素
              this.verifiyState = 10;
              reject();
            },
            onClose: () => this.liveness(action).then(resolve, reject), // 重做人脸识别
            onCancel: () => this.liveness(action).then(resolve, reject), // 重做人脸识别
            // eslint-disable-next-line no-unused-vars
          }, h => ( // render 插槽渲染弹框
            <div slot="content">
              <img src={verifyFail} width={109} height={90} />
              <h3 style={{ margin: '12px 0', fontSize: '17px', color: '#222' }}>人脸识别不通过</h3>
              <p style={{
                padding: '0 20px', textAlign: 'left', fontSize: '13px', color: '#666',
              }}>
                失败原因：{errorMessage.message}<br/>
                您可重新进行人脸识别，也可尝试银行卡四要素认证
              </p>
            </div>
          )).show();
          console.error(errorMessage);
        };
        // 指定动作活体检测
        const liveness = new Liveness({
          // apiId: '626b74c23fd14bf4a1d92f4209008017',
          // apiSecret: '39b729e74f6c4daca63505ac6192dec4',
          // // 设置代理服务器地址
          host: config.linkfaceProxyUrl,
          // 在用户采集到视频之后，请求公有云接口之前执行
          // beforeCheck(data) {
          //   console.log('before data: ', data);
          // },
          // 活体检测完成后的回调函数
          onChecked: (file) => {
            // this.toast = this.$createToast({
            //   txt: '识别中, 预计时间1-3分钟...',
            //   type: 'loading',
            //   mask: true,
            //   time: 0,
            // }).show();

            // 上传视频到文件服务
            const formData = new FormData();
            formData.append('bucketName', 'totodi-other');
            formData.append('file', file);

            axios.post(`${config.baseUrl}/zuul/file-service/oos/uploadFile`, formData, {
              headers: uploadHeaders(),
            }).then((resp) => {
              const { data } = resp;
              const fileData = data.data.list[0];
              if (!data.code === 0 || !fileData) {
                return Promise.reject(Error(`上传文件失败!${data.msg}`));
              }
              return tencentLivenessRecognition({
                name: this.model.userName,
                idType: '身份证',
                idCard: this.model.idNo,
                nation: '中国',
                type: 2,
                validateData: action,
                videoInfo: JSON.stringify(fileData),
              }).then((res) => {
                if (res.code !== 0) {
                  return Promise.reject(Error(res.msg));
                }
                resolve({ faceRecognitionResults: res.data.bean.faceRecognitionResults, faceVideo: fileData });
                return res;
              });
            }).catch((err) => {
              livenessErrorHandler(err);
            }).finally(() => {
              liveness.unloading();
            });
          },
          // 活体检测发生错误后的回调函数
          onError: (errorMessage) => {
            livenessErrorHandler(errorMessage);
          },
          // 本次活体检测使用的动作
          action,
        });
        liveness.show();
      });
    },

    async submitHandler() {
      const res = await authentication({
        sealId: this.$route.params.sealId,
        auType: 2,
        ...this.model,
      });
      if (res.code === 0) {
        this.verifiyState = 20;
      } else {
        this.$createToast({
          type: 'txt',
          txt: res.msg,
          mask: true,
          time: 2000,
        }).show();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.root-box {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.flex-1 {
  flex: 1;
}
.tip-box {
  display: flex;
  flex-direction: column;
}
.title {
  margin: 39px 0 29px;
  font-size: 17px;
  color: #222222;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
}
.content-box {
  flex: 1;
}
.content {
  padding: 0 31px;
  font-size: 15px;
  color: #222222;
  letter-spacing: 0;
  text-align: justify;
  text-indent: 2em;
  line-height: 24px;
}
.bottom {
  padding: 16px 16px 10px;
  border-top: 1px solid #F0F0F0;
  text-align: center;
}
.four-elements-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: rgb(245,245,245);
}
.four-elements-span {
  padding: 16px;
  font-size: 14px;
  color: #979797;
}
.white-background {
  background: white;
}
.success-box {
  padding-top: 100px;
  text-align: center;
}
.info {
  margin: 20px 0;
  font-size: 17px;
  color: #222222;
}
.sub-info {
  width: 200px;
  margin: 0 auto;
  font-size: 13px;
  color: #666666;
  line-height: 20px;
}
</style>

<style>
/* linkface 活体识别 sdk 样式 */
@import url('~@/components/liveness/stylesheets/liveness.css');
</style>
